<!-- navbar.component.html -->
<nav class="w-full">
  <!-- Desktop Navigation - Hidden on mobile, visible on tablet+ -->
  <ul class="hidden md:flex select-none relative list-none gap-6 rounded-b-[1.625rem] border-r border-b border-l border-grey-100 bg-white/70 shadow-[0_4px_20px_0_rgba(0,0,0,0.04)] px-0.5">
    @for (item of navItems(); track item) {
      <li class="text-[0.85rem] nav-item capitalize cursor-pointer px-3 pt-2 pb-2
                  transition-all duration-300 ease-out z-10 relative select-none group"
          [class.active]="activeItem() === item"
          [ngClass]="{
            'text-primary-900 font-medium': activeItem() === item,
            'text-grey-400 font-normal': activeItem() !== item
          }"
          (click)="setActive(item)"
          [routerLink]="item.link">

        <!-- Hover Background Preview -->
        @if (activeItem() !== item) {
          <span class="absolute inset-0 bg-[rgba(255,255,255,0.3)] h-9
                     bg-opacity-10 shadow-[0_4px_20px_0_rgba(0,0,0,0.04)] transition-all duration-300 ease-out -z-10
                     opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100"
                     [ngClass]="{
                      'rounded-bl-[1.625rem]': navItems()[0] === item,
                      'rounded-br-[1.625rem]': navItems()[navItems().length - 1] === item,
                    }"
                    ></span>
        }

        <span [class]="item.icon"
              [ngClass]="{
                'text-primary-900': activeItem() === item,
                'text-grey-400': activeItem() !== item
              }"
              class="text-[0.85rem] mr-2 transition-all duration-300 ease-out">
        </span>
        {{ item.label }}
      </li>
    }   

    <!-- Active Indicator -->
    <span class="absolute bg-[rgba(255,255,255,0.5)] h-9 border border-primary-100
                 bg-opacity-20 shadow-[0_4px_20px_0_rgba(0,0,0,0.04)] transition-all duration-200 ease-out z-0 pointer-events-none"
                 [ngClass]="{
                  'rounded-bl-[1.625rem]': isActiveItemFirst(),
                  'rounded-br-[1.625rem]': isActiveItemLast(),
                  'rounded-none': !isActiveItemOnEdge()
                }"
          [style.left]="indicatorPosition"
          [style.width]="indicatorWidth">
    </span>
  </ul>

  <!-- Mobile Navigation - Visible on mobile, hidden on tablet+ -->
  <ul class="flex md:hidden p-0 m-0 justify-around items-center list-none gap-0 w-full">
    @for (item of mobileNavItems(); track item) {
      <li class="mobile-nav-item relative min-w-[50px] max-w-[80px] flex-1 flex flex-col items-center justify-center 
                  cursor-pointer py-1.5 px-0 select-none 
                  [-webkit-tap-highlight-color:transparent] active:scale-[0.92]
                  transition-transform duration-150 ease-out"
          [class.active]="activeItem() === item"
          (click)="setActive(item)"
          [routerLink]="item.link">
        <span [class]="item.icon"
              class="text-2xl mb-0.5 transition-[color,transform] duration-150 ease-out"
              [ngClass]="{
                'text-primary-600 -translate-y-0.5': activeItem() === item,
                'text-grey-400': activeItem() !== item
              }">
        </span>
        <span class="text-[0.6rem] font-medium transition-colors duration-150 ease-out"
              [ngClass]="{
                'text-primary-900': activeItem() === item,
                'text-grey-500': activeItem() !== item
              }">
          {{ item.label }}
        </span>
      </li>
    }
  </ul>
</nav>
